/**
 * Cookie-consent banner altijd klikbaar houden.
 *
 * De CSS-only fix (sticky-atc.css) loste het z-index-probleem niet betrouwbaar
 * op - vermoedelijk omdat de banner (Shopify's native #shopify-pc__banner of
 * een los geinstalleerde consent-app) pas ná het laden van deze CSS dynamisch
 * in de DOM wordt geinjecteerd, met eigen inline stijlen die de CSS-regels
 * overschrijven. Deze versie wacht via een MutationObserver tot het element
 * verschijnt en zet de stijlen dan direct op het element zelf (inline, dus
 * hoogste specificiteit, wint altijd van externe/inline app-CSS).
 */
(function () {
  'use strict';

  var SELECTORS = [
    '#shopify-pc__banner',
    '.shopify-pc__banner',
    '.cookieConsent',
    '[id*="cookie-consent" i]',
    '[class*="cookie-consent" i]',
    '[id*="cookiebanner" i]',
    '[class*="cookiebanner" i]'
  ];

  function forceOnTop(el) {
    el.style.setProperty('z-index', '2147483647', 'important');
    el.style.setProperty('pointer-events', 'auto', 'important');
  }

  function matchesCookieBanner(el) {
    if (!(el instanceof Element)) {
      return false;
    }

    return SELECTORS.some(function (selector) {
      try {
        return el.matches(selector);
      } catch (e) {
        return false;
      }
    });
  }

  function scanExisting() {
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(forceOnTop);
    });
  }

  scanExisting();

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (matchesCookieBanner(node)) {
          forceOnTop(node);
        }

        if (node.querySelectorAll) {
          SELECTORS.forEach(function (selector) {
            node.querySelectorAll(selector).forEach(forceOnTop);
          });
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
